export default class ItemNumberInputClass {
  constructor() {
    // if needed
  }

  format(value = '') {
    let updated_value = value;
    try {
      updated_value = String(updated_value.toUpperCase());
    } catch (err) {
      logError(err);
    }
    return updated_value;
  }
}
